import React, { Component } from "react";
import { Navigate } from 'react-router-dom';
import { userService } from "../../_services";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Alert, AlertDescription } from "../ui/alert";
import { Loader2, Eye, EyeOff, CheckCircle } from "lucide-react";

class Account_Info_page extends Component {
    _isMounted = false;
    
    constructor(props) {
        super(props);
        this.state = {
            UserId: '',
            UserName: '',
            Fname: '',
            Lname: '',
            Phone: '',
            Email: '',
            Address1: '',
            Address2: '',
            Country: 'United States',
            State: '',
            City: '',
            Zip: '',
            shortname: '',
            fullName: '',
            account_info: '',
            save_msg: '',
            saveSuccess: false,
            show_Payment_popup: false,
            show_Userdetail_popup: false,
            IsUserExist: false,
            IsRedirect: false,
            errors: {
                UserName: '',
                Fname: '',
                Lname: '',
                Phone: '',
                Email: '',
                Address1: '',
                Address2: '',
                Country: '',
                State: '',
                City: '',
                Zip: ''
            },
            UserData: [],
            AddressData: {
                Country: [
                    'United States'
                ],
                State: [
                    { name: 'Alabama', value: 'AL' },
                    { name: 'Alaska', value: 'AK' },
                    { name: 'Arizona', value: 'AZ' },
                    { name: 'Arkansas', value: 'AR' },
                    { name: 'California', value: 'CA' },
                    { name: 'Colorado', value: 'CO' },
                    { name: 'Connecticut', value: 'CT' },
                    { name: 'Delaware', value: 'DE' },
                    { name: 'Florida', value: 'FL' },
                    { name: 'Georgia', value: 'GA' },
                    { name: 'Hawaii', value: 'HI' },
                    { name: 'Idaho', value: 'ID' },
                    { name: 'Illinois', value: 'IL' },
                    { name: 'Indiana', value: 'IN' },
                    { name: 'Iowa', value: 'IA' },
                    { name: 'Kansas', value: 'KS' },
                    { name: 'Kentucky', value: 'KY' },
                    { name: 'Louisiana', value: 'LA' },
                    { name: 'Maine', value: 'ME' },
                    { name: 'Maryland', value: 'MD' },
                    { name: 'Massachusetts', value: 'MA' },
                    { name: 'Michigan', value: 'MI' },
                    { name: 'Minnesota', value: 'MN' },
                    { name: 'Mississippi', value: 'MS' },
                    { name: 'Missouri', value: 'MO' },
                    { name: 'Montana', value: 'MT' },
                    { name: 'Nebraska', value: 'NE' },
                    { name: 'Nevada', value: 'NV' },
                    { name: 'New Hampshire', value: 'NH' },
                    { name: 'New Jersey', value: 'NJ' },
                    { name: 'New Mexico', value: 'NM' },
                    { name: 'New York', value: 'NY' },
                    { name: 'North Carolina', value: 'NC' },
                    { name: 'North Dakota', value: 'ND' },
                    { name: 'Ohio', value: 'OH' },
                    { name: 'Oklahoma', value: 'OK' },
                    { name: 'Oregon', value: 'OR' },
                    { name: 'Pennsylvania', value: 'PA' },
                    { name: 'Rhode Island', value: 'RI' },
                    { name: 'South Carolina', value: 'SC' },
                    { name: 'South Dakota', value: 'SD' },
                    { name: 'Tennessee', value: 'TN' },
                    { name: 'Texas', value: 'TX' },
                    { name: 'Utah', value: 'UT' },
                    { name: 'Vermont', value: 'VT' },
                    { name: 'Virginia', value: 'VA' },
                    { name: 'Washington', value: 'WA' },
                    { name: 'West Virginia', value: 'WV' },
                    { name: 'Wisconsin', value: 'WI' },
                    { name: 'Wyoming', value: 'WY' }
                ]
            },
            password_box: false,
            saveloader: false,
            // Change password states
            Current_password: '',
            New_password: '',
            Confirm_password: '',
            passwordErrors: {
                Current_password: '',
                New_password: '',
                Confirm_password: ''
            },
            passwordLoader: false,
            showCurrentPassword: false,
            showNewPassword: false,
            showConfirmPassword: false
        };
        
        this.noerrors = {
            UserName: '',
            Fname: '',
            Lname: '',
            Phone: '',
            Email: '',
            Address1: '',
            Address2: '',
            Country: '',
            State: '',
            City: '',
            Zip: ''
        };
        
        this.noPasswordErrors = {
            Current_password: '',
            New_password: '',
            Confirm_password: ''
        };
        
        this.toogle_request_pop = this.toogle_request_pop.bind(this);
        this.submit_setting = this.submit_setting.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        try {
            setTimeout(() => {
                let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                this.GetUserAccountInfo(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            }, 1200);
        } catch {
            this.logout();
        }
    }

    toogle_request_pop = (e) => {
        if (e) e.stopPropagation();
        this.setState({ 
            password_box: !this.state.password_box,
            Current_password: '',
            New_password: '',
            Confirm_password: '',
            passwordErrors: this.noPasswordErrors,
            showCurrentPassword: false,
            showNewPassword: false,
            showConfirmPassword: false
        });
    };

    GetUserAccountInfo(UserId, UserName) {
        try {
            userService.GetUserAccountInfo(UserId, UserName).then(apidata => {
                try {
                    if (apidata.length > 0) {
                        if (apidata[0].code !== "-1") {
                            this.setState({
                                UserData: apidata,
                                UserName: apidata[0].username,
                                UserId: UserId,
                                Fname: apidata[0].fname,
                                Lname: apidata[0].lname,
                                Phone: apidata[0].phone,
                                Email: apidata[0].email,
                                Address1: apidata[0].address1,
                                Address2: apidata[0].address2,
                                State: apidata[0].stateName,
                                City: apidata[0].cityName,
                                Zip: apidata[0].zipCode
                            });
                            let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
                            this.setState({
                                shortname: usernamedata.split(':')[0],
                                fullName: usernamedata.split(':')[1]
                            });
                            let userinfo = window.atob(localStorage.getItem('_file_info'));
                            this.setState({ account_info: userinfo });
                        }
                    }
                } catch (error) {
                }
            });
        } catch (error) {
        }
    }

    logout() {
        userService.logout();
        this.state.UserData = [];
    }

    submit_setting(event) {
        event.preventDefault();
        let errors = this.state.errors;
        try {
            userService.GetUserNameFilter(this.state.UserName).then(apidata => {
                if (apidata.length > 0) {
                    if (apidata[0].code !== '0') {
                        errors.UserName = apidata[0].message;
                    }
                    if (this.state.UserName) {
                        let str = this.state.UserName;
                        str = str.replace(/^\s+/, '');
                        this.setState({ UserName: str });
                        if (this.state.UserName !== "") {
                            var special = /^[0-9\b]+$/;
                            if (this.state.UserName.match(special)) {
                                errors.UserName = 'This Username not allowed';
                            }
                        }
                    }
                    userService.GetPhoneNoValidate(this.state.Phone).then(apidata => {
                        if (apidata[0].code !== "1") {
                            errors.Phone = 'Invalid Phone Number';
                        } else {
                            if (apidata[0].message != null) {
                                this.setState({ Phone: apidata[0].message });
                            }
                        }

                        if (this.state.UserName === "" || this.state.UserName.length < 5)
                            errors.UserName = 'Username must be at least 5 characters long';
                        if (this.state.UserName.includes(' '))
                            errors.UserName = 'Username does not allow space';
                        if (this.state.Fname.length < 3)
                            errors.Fname = 'First Name must be at least 3 characters long';
                        if (this.state.Lname.length < 2)
                            errors.Lname = 'Last Name must be at least 2 characters long';
                        if (userService.ValidPhone(this.state.Phone) === false && this.state.Phone !== "")
                            errors.Phone = "Please enter valid Phone Number";
                        if (this.state.Email.length < 1)
                            errors.Email = "Enter your email";
                        if (userService.ValidEmailRegex(this.state.Email) === false && this.state.Email !== "")
                            errors.Email = 'Invalid Email';
                        if (this.state.Address1.length < 1)
                            errors.Address1 = 'Please Input street address';
                        if (this.state.City.length < 2)
                            errors.City = 'Please input city';
                        if (this.state.State === '')
                            errors.State = 'Please Select State';
                        if (this.state.Zip.length < 5 || this.state.Zip.length > 5)
                            errors.Zip = 'Please input valid zipcode';

                        if (JSON.stringify(errors) !== JSON.stringify(this.noerrors)) {
                            this.setState({ errors: errors });
                        } else {
                            this.setState({ saveloader: true });
                            let states_data = this.state;
                            this.SetUserAccountInfo(
                                states_data.UserId,
                                states_data.UserName,
                                states_data.Fname,
                                states_data.Lname,
                                states_data.Email,
                                states_data.Phone,
                                states_data.Address1,
                                states_data.Address2,
                                states_data.Country,
                                states_data.State,
                                states_data.City,
                                states_data.Zip
                            );
                        }
                    });
                }
            });
        } catch (error) {
        }
    }

    HandleInput = (event) => {
        let errors = this.state.errors;
        if (event.target.name === "Phone") {
            var regex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
            if (event.target.value.match(regex)) {
                this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                errors[event.target.name] = '';
                this.setState({ errors: errors });
            }
        }
        if (event.target.name === "Fname" || event.target.name === "Lname") {
            var special = /^[a-zA-Z]+$/g;
            if (event.target.value.match(special) || event.target.value === '') {
                this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                errors[event.target.name] = '';
                this.setState({ errors: errors });
            } else {
                return false;
            }
        }
        if (event.target.name === "City") {
            if (event.target.value !== "") {
                let special = /^[a-zA-Z ]*$/;
                if (event.target.value.match(special) || event.target.value === '') {
                    this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                    errors[event.target.name] = '';
                    this.setState({ errors: errors });
                } else {
                    return false;
                }
            } else {
                this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
            }
        }
        if (event.target.name === "Zip") {
            if (event.target.value !== "" || event.target.value === "") {
                let special = /^[0-9\b]+$/;
                if (event.target.value.match(special) || event.target.value === "") {
                    this.setState({ [event.target.name]: event.target.value, extra_info: false, extra_info_msg: '' });
                    errors[event.target.name] = '';
                    this.setState({ errors: errors });
                }
            }
        } else {
            this.setState({ [event.target.name]: event.target.value });
            errors[event.target.name] = '';
            this.setState({ errors: errors });
        }
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    SetUserAccountInfo(UserId, UserName, Fname, Lname, Email, Phone, Address1, Address2, CountryName, StateName, CityName, ZipCode) {
        try {
            userService.SetUserAccountInfo(UserId, UserName, Fname, Lname, Email, Phone, Address1, Address2, CountryName, StateName, CityName, ZipCode).then(apidata => {
                if (apidata.length > 0) {
                    if (apidata[0].code !== '-1') {
                        localStorage.setItem('_file_info', window.btoa('0'));
                        let userinfo = window.atob(localStorage.getItem('_file_info'));
                        this.setState({
                            account_info: userinfo,
                            saveSuccess: true,
                            save_msg: "Saved Successfully",
                            saveloader: false
                        });
                        setTimeout(() => {
                            this.setState({ saveSuccess: false });
                        }, 2000);
                    } else {
                        this.setState({
                            saveSuccess: true,
                            save_msg: apidata[0].message,
                            saveloader: false
                        });
                        setTimeout(() => {
                            this.setState({ saveSuccess: false });
                        }, 3000);
                    }
                } else {
                    this.setState({ saveloader: false });
                }
            });
        } catch (error) {
        }
    }

    removeError = (event) => {
        let errors = this.state.errors;
        errors[event.target.previousElementSibling.previousElementSibling.name] = '';
        this.setState({ errors: errors });
    };

    // Change Password Methods (from ChangepassPop.js)
    HandlePasswordInput = (event) => {
        let passwordErrors = this.state.passwordErrors;
        this.setState({ [event.target.name]: event.target.value });
        passwordErrors[event.target.name] = '';
        this.setState({ passwordErrors: passwordErrors });
    };

    handle_save_continue_btn = (event) => {
        event.preventDefault();
        let passwordErrors = this.state.passwordErrors;
        
        if (this.state.Current_password.length < 6)
            passwordErrors.Current_password = 'At least 6 characters in length';
        if (this.state.New_password.length < 6)
            passwordErrors.New_password = 'At least 6 characters in length';
        if (this.state.New_password !== this.state.Confirm_password)
            passwordErrors.Confirm_password = 'Password do not match';
            
        if (JSON.stringify(passwordErrors) !== JSON.stringify(this.noPasswordErrors)) {
            this.setState({ passwordErrors: passwordErrors });
        } else {
            let pwd_data = this.state;
            this.ResetPassword(
                pwd_data.UserId,
                pwd_data.UserName,
                pwd_data.Current_password,
                pwd_data.New_password,
                pwd_data.Confirm_password,
                event
            );
            this.setState({ passwordLoader: true });
        }
    };

    ResetPassword(UserId, UserName, Current_Pwd, New_Pwd, Confirm_New_Pwd, event) {
        try {
            userService.ResetPassword(UserId, UserName, Current_Pwd, New_Pwd, Confirm_New_Pwd).then(apidata => {
                try {
                    if (apidata.length > 0) {
                        let passwordErrors = this.state.passwordErrors;
                        if (apidata[0].code === "1") {
                            this.setState({ passwordLoader: false });
                            setTimeout(() => {
                                this.toogle_request_pop(event);
                            }, 600);
                        }
                        if (apidata[0].code === "-1") {
                            passwordErrors.Current_password = apidata[0].message;
                            this.setState({ passwordErrors: passwordErrors, passwordLoader: false });
                        }
                        if (apidata[0].code === "-2") {
                            passwordErrors.New_password = apidata[0].message;
                            this.setState({ passwordErrors: passwordErrors, passwordLoader: false });
                        }
                    }
                } catch (error) {
                }
            });
        } catch (error) {
        }
    }

    render() {
        if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true)
            return <Navigate to="/signup" />;
        
        if (this.state.IsRedirect === true)
            return <Navigate to={{ pathname: "/summary" }} />;

        const { errors, passwordErrors } = this.state;
        const isLoading = this.state.UserData.length === 0 || this.state.UserData == null;

        return (
            <div className="space-y-6">
                {/* Page Header */}
                <div>
                    <h1 className="text-3xl font-bold tracking-tight text-foreground">Account Information</h1>
                </div>

                {/* Success Message */}
                {this.state.saveSuccess && (
                    <Alert className="bg-green-50 border-green-200">
                        <CheckCircle className="h-4 w-4 text-green-600" />
                        <AlertDescription className="text-green-800">
                            {this.state.save_msg}
                        </AlertDescription>
                    </Alert>
                )}

                {/* Loading State */}
                {isLoading ? (
                    <Card>
                        <CardContent className="flex items-center justify-center py-12">
                            <Loader2 className="h-12 w-12 animate-spin text-brand-accent" />
                        </CardContent>
                    </Card>
                ) : (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* Personal Information Card */}
                        <Card>
                            <CardContent className="p-6">
                                <h3 className="text-lg font-semibold mb-4">Personal</h3>
                                <div className="space-y-4">
                                    {/* Username */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="UserName"
                                            value={this.state.UserName}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.UserName ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Username
                                        </label>
                                        {errors.UserName && (
                                            <p className="text-red-500 text-xs mt-1">{errors.UserName}</p>
                                        )}
                                    </div>

                                    {/* First Name */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Fname"
                                            value={this.state.Fname}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.Fname ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            First Name
                                        </label>
                                        {errors.Fname && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Fname}</p>
                                        )}
                                    </div>

                                    {/* Last Name */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Lname"
                                            value={this.state.Lname}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.Lname ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Last Name
                                        </label>
                                        {errors.Lname && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Lname}</p>
                                        )}
                                    </div>

                                    {/* Phone */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Phone"
                                            value={this.state.Phone}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.Phone ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Phone
                                        </label>
                                        {errors.Phone && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Phone}</p>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Email"
                                            value={this.state.Email}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            disabled
                                            className={`peer h-12 ${errors.Email ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Email
                                        </label>
                                        {errors.Email && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Email}</p>
                                        )}
                                    </div>
                                </div>
                            </CardContent>
                        </Card>

                        {/* Address Information Card */}
                        <Card>
                            <CardContent className="p-6">
                                <h3 className="text-lg font-semibold mb-4">Address</h3>
                                <div className="space-y-4">
                                    {/* Street Address */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Address1"
                                            value={this.state.Address1}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.Address1 ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Street Address
                                        </label>
                                        {errors.Address1 && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Address1}</p>
                                        )}
                                    </div>

                                    {/* Address Line 2 */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Address2"
                                            value={this.state.Address2}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.Address2 ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Address Line 2
                                        </label>
                                        {errors.Address2 && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Address2}</p>
                                        )}
                                    </div>

                                    {/* Country */}
                                    <div className="relative">
                                        <Select
                                            value={this.state.Country}
                                            onValueChange={(value) => this.setState({ Country: value })}
                                            disabled
                                        >
                                            <SelectTrigger className="h-12">
                                                <SelectValue />
                                            </SelectTrigger>
                                            <SelectContent>
                                                {this.state.AddressData.Country.map(item => (
                                                    <SelectItem key={item} value={item}>{item}</SelectItem>
                                                ))}
                                            </SelectContent>
                                        </Select>
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground">
                                            Country
                                        </label>
                                    </div>

                                    {/* State */}
                                    <div className="relative">
                                        <Select
                                            value={this.state.State}
                                            onValueChange={(value) => this.setState({ State: value })}
                                        >
                                            <SelectTrigger className={`h-12 ${errors.State ? 'border-red-500' : ''}`}>
                                                <SelectValue placeholder="Select state" />
                                            </SelectTrigger>
                                            <SelectContent>
                                                {this.state.AddressData.State.map(item => (
                                                    <SelectItem key={item.name} value={item.value}>
                                                        {item.name}
                                                    </SelectItem>
                                                ))}
                                            </SelectContent>
                                        </Select>
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground">
                                            State *
                                        </label>
                                        {errors.State && (
                                            <p className="text-red-500 text-xs mt-1">{errors.State}</p>
                                        )}
                                    </div>

                                    {/* City */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="City"
                                            value={this.state.City}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.City ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            City
                                        </label>
                                        {errors.City && (
                                            <p className="text-red-500 text-xs mt-1">{errors.City}</p>
                                        )}
                                    </div>

                                    {/* ZIP Code */}
                                    <div className="relative">
                                        <Input
                                            type="text"
                                            name="Zip"
                                            value={this.state.Zip}
                                            onChange={this.HandleInput}
                                            onFocus={this.HandleInput}
                                            placeholder=" "
                                            className={`peer h-12 ${errors.Zip ? 'border-red-500' : ''}`}
                                        />
                                        <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            ZIP / Postal Code *
                                        </label>
                                        {errors.Zip && (
                                            <p className="text-red-500 text-xs mt-1">{errors.Zip}</p>
                                        )}
                                    </div>
                                </div>
                            </CardContent>
                        </Card>

                        {/* Security Card */}
                        <Card>
                            <CardContent className="p-6">
                                <h3 className="text-lg font-semibold mb-4">Security</h3>
                                <Button
                                    variant="outline"
                                    onClick={this.toogle_request_pop}
                                    className="w-full"
                                >
                                    Change Password
                                </Button>
                            </CardContent>
                        </Card>

                        {/* Save Button Card */}
                        <Card>
                            <CardContent className="p-6 flex flex-col items-center justify-center">
                                <Button
                                    variant="secondary"
                                    size="lg"
                                    onClick={this.submit_setting}
                                    disabled={this.state.saveloader}
                                    className="w-full max-w-xs"
                                >
                                    {this.state.saveloader ? (
                                        <>
                                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                            Saving...
                                        </>
                                    ) : (
                                        'Save Profile Settings'
                                    )}
                                </Button>
                            </CardContent>
                        </Card>
                    </div>
                )}

                {/* Change Password Dialog */}
                {this.state.password_box && (
                    <Dialog open={this.state.password_box} onOpenChange={this.toogle_request_pop}>
                        <DialogContent>
                            <DialogHeader>
                                <DialogTitle>Change Password</DialogTitle>
                                <DialogDescription>
                                    <div className="space-y-1">
                                        <p>Your new password must:</p>
                                        <p>Be at least 6 characters in length</p>
                                        <p>Not be same as your current password</p>
                                        <p>Not contain common passwords.</p>
                                    </div>
                                </DialogDescription>
                            </DialogHeader>

                            <div className="space-y-4 mt-4">
                                {/* Current Password */}
                                <div className="relative">
                                    <Input
                                        type={this.state.showCurrentPassword ? "text" : "password"}
                                        name="Current_password"
                                        value={this.state.Current_password}
                                        onChange={this.HandlePasswordInput}
                                        onFocus={this.HandlePasswordInput}
                                        placeholder=" "
                                        maxLength={30}
                                        className={`peer h-12 pr-10 ${passwordErrors.Current_password ? 'border-red-500' : ''}`}
                                    />
                                    <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                        Current Password
                                    </label>
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ showCurrentPassword: !this.state.showCurrentPassword })}
                                        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
                                    >
                                        {this.state.showCurrentPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                                    </button>
                                    {passwordErrors.Current_password && (
                                        <p className="text-red-500 text-xs mt-1">{passwordErrors.Current_password}</p>
                                    )}
                                </div>

                                {/* New Password */}
                                <div className="relative">
                                    <Input
                                        type={this.state.showNewPassword ? "text" : "password"}
                                        name="New_password"
                                        value={this.state.New_password}
                                        onChange={this.HandlePasswordInput}
                                        onFocus={this.HandlePasswordInput}
                                        placeholder=" "
                                        maxLength={30}
                                        className={`peer h-12 pr-10 ${passwordErrors.New_password ? 'border-red-500' : ''}`}
                                    />
                                    <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                        New Password
                                    </label>
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
                                        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
                                    >
                                        {this.state.showNewPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                                    </button>
                                    {passwordErrors.New_password && (
                                        <p className="text-red-500 text-xs mt-1">{passwordErrors.New_password}</p>
                                    )}
                                </div>

                                {/* Confirm Password */}
                                <div className="relative">
                                    <Input
                                        type={this.state.showConfirmPassword ? "text" : "password"}
                                        name="Confirm_password"
                                        value={this.state.Confirm_password}
                                        onChange={this.HandlePasswordInput}
                                        onFocus={this.HandlePasswordInput}
                                        placeholder=" "
                                        maxLength={30}
                                        className={`peer h-12 pr-10 ${passwordErrors.Confirm_password ? 'border-red-500' : ''}`}
                                    />
                                    <label className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                        Confirm Password
                                    </label>
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                                        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
                                    >
                                        {this.state.showConfirmPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                                    </button>
                                    {passwordErrors.Confirm_password && (
                                        <p className="text-red-500 text-xs mt-1">{passwordErrors.Confirm_password}</p>
                                    )}
                                </div>
                            </div>

                            <DialogFooter className="mt-6">
                                <Button
                                    variant="outline"
                                    onClick={this.toogle_request_pop}
                                    disabled={this.state.passwordLoader}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={this.handle_save_continue_btn}
                                    disabled={this.state.passwordLoader}
                                >
                                    {this.state.passwordLoader ? (
                                        <>
                                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                            Saving...
                                        </>
                                    ) : (
                                        'Save Changes'
                                    )}
                                </Button>
                            </DialogFooter>
                        </DialogContent>
                    </Dialog>
                )}
            </div>
        );
    }
}

export default Account_Info_page;
